import React from 'react'
import coloradoLogo from '../images/colorado.svg'

export default () => (
  <footer>
    <img src={coloradoLogo} alt='Made with &hearts; in Denver, Colorado' />
  </footer>
)



// WEBPACK FOOTER //
// ./src/layouts/footer.js